module.exports = __webpack_public_path__ + "0b99ce3e6838f9beb08e2f5eff12276f.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-20.png
// module id = 114
// module chunks = 0